import { ReactNode, useContext } from "react";
import { CustomState, CustomStateHook } from "../../Hooks/State.hook";
import { StyledScheduleDialog } from "./style";
import { RegistrationButton } from "../../styles/registrationButton";
import { IoMdClose } from "react-icons/io";
import { SocketContext } from "../../contexts/global/SocketContext";
import "react-calendar/dist/Calendar.css";
import "react-time-picker/dist/TimePicker.css";
import { LoginContext, currentRoute } from "../../contexts/global/LoginContext";
import Input from "../Input";
import { defaultInput100 } from "../../components-variants/defaultInputs";
import { schedulesApi } from "../../services/api";
import { toast } from "react-toastify";
import { RunningAttendanceDetails, SpecificAttendanceDetails } from "../../interfaces/Attendances.interfaces";

interface ScheduleDialogProps {
    modalState: CustomStateHook<ReactNode>;
    attendance: SpecificAttendanceDetails | RunningAttendanceDetails;
    toUserId: number;
};

export const ScheduleDialog = ({ modalState, attendance, toUserId }: ScheduleDialogProps) => {
    const selectedDate = CustomState<Date | null>(null);
    const minDate = new Date();
    const { socket } = useContext(SocketContext);
    const { user } = useContext(LoginContext);

    async function scheduleAttendance() {
        if (socket.value && user && selectedDate.value) {

            await schedulesApi.post<{ message: string }>("", {
                scheduleDate: selectedDate.value.toISOString(),
                whatsappId: attendance.CODIGO_NUMERO,
                toUserId,
                byUserId: user.CODIGO,
                sectorId: user.SETOR
            })
                .then(res => toast.success(res.data.message))
                .catch(err => toast.error(err.response ? err.response.data?.message : err.message));

            modalState.reset();
        };
    };

    return (
        <StyledScheduleDialog>
            <header>
                <h2> Agendar retorno </h2>
                <IoMdClose onClick={modalState.reset} />
            </header>

            <Input
                {...defaultInput100}
                $fontSize={1}
                $padding={[0.5, 0.5]}
                type="datetime-local"
                onChange={(e) => selectedDate.set(new Date(e.target.value))}
                min={minDate.toISOString().slice(0, 16)}
            />
            <RegistrationButton
                disabled={!selectedDate.value || selectedDate.value <= minDate}
                onClick={scheduleAttendance}

            >
                Agendar
            </RegistrationButton>
        </StyledScheduleDialog>
    );
};